import React, { useState } from "react";
import { PencilSimple, CheckCircle } from "@phosphor-icons/react";
import { LineEditor } from "./LineEditor";
import { LINE_TYPES, aud } from "./ui";

export function LinesTable({ lines, onSaved, showClaim = true }) {
  const [editing, setEditing] = useState(null);
  if (!lines?.length) return <div className="text-sm text-neutral-500 py-4">No repair lines.</div>;
  return (
    <div className="overflow-x-auto" data-testid="wi-lines-table">
      <table className="w-full text-xs">
        <thead className="text-[0.6rem] uppercase tracking-wider text-neutral-500 text-left">
          <tr className="border-b border-neutral-800">
            {showClaim && <th className="py-2 pr-3">Claim</th>}
            <th className="py-2 pr-3">Repair line</th><th className="py-2 pr-3">Type</th><th className="py-2 pr-3 text-right">Qty</th>
            <th className="py-2 pr-3 text-right">Hrs</th><th className="py-2 pr-3 text-right">Ex GST</th><th className="py-2 pr-3">Benchmark</th><th />
          </tr>
        </thead>
        <tbody>
          {lines.map((l) => (
            <tr key={l.id} className="border-b border-neutral-900 align-top hover:bg-white/[0.02]" data-testid="wi-line-row">
              {showClaim && (
                <td className="py-2 pr-3 whitespace-nowrap">
                  <div className="font-mono text-neutral-200">{l.otma || l.chassis || "—"}</div>
                  <div className="text-neutral-600">{l.claim_date} · {l.repairer || l.dealer || ""}</div>
                </td>
              )}
              <td className="py-2 pr-3 min-w-[240px]">
                <div className="text-neutral-200">{l.standardised_description || l.description}</div>
                <div className="text-neutral-600 line-clamp-2">{l.description}</div>
                <div className="text-neutral-500 mt-0.5">{l.system} · {l.component}{l.spec ? ` · ${l.spec}` : ""}</div>
              </td>
              <td className="py-2 pr-3 whitespace-nowrap text-neutral-400">{LINE_TYPES[l.line_type] || l.line_type}</td>
              <td className="py-2 pr-3 text-right tabular-nums text-neutral-400">{l.qty ?? "—"}</td>
              <td className="py-2 pr-3 text-right tabular-nums text-neutral-400">{l.labour_hours ?? "—"}</td>
              <td className="py-2 pr-3 text-right tabular-nums text-white">{aud(l.line_total_ex_gst, 2)}</td>
              <td className="py-2 pr-3">
                {l.benchmark?.eligible
                  ? <span className="inline-flex items-center gap-1 text-[#73bf44]"><CheckCircle size={12} weight="fill" /> Comparable</span>
                  : <span className="text-neutral-500">{l.benchmark?.reason || "—"}</span>}
                {l.admin_edited && <div className="text-[0.6rem] text-sky-300 mt-0.5">corrected</div>}
              </td>
              <td className="py-2">
                <button onClick={() => setEditing(l)} className="p-1.5 rounded-md text-neutral-500 hover:text-white hover:bg-white/[0.06]" title="Correct this line" data-testid="wi-line-edit-btn">
                  <PencilSimple size={14} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {editing && <LineEditor line={editing} onClose={() => setEditing(null)} onSaved={onSaved} />}
    </div>
  );
}
